import { render, staticRenderFns } from "./dcopsCrossAudit.vue?vue&type=template&id=fe27a734&scoped=true"
import script from "./dcopsCrossAudit.vue?vue&type=script&lang=js"
export * from "./dcopsCrossAudit.vue?vue&type=script&lang=js"
import style0 from "./dcopsCrossAudit.vue?vue&type=style&index=0&id=fe27a734&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe27a734",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe27a734')) {
      api.createRecord('fe27a734', component.options)
    } else {
      api.reload('fe27a734', component.options)
    }
    module.hot.accept("./dcopsCrossAudit.vue?vue&type=template&id=fe27a734&scoped=true", function () {
      api.rerender('fe27a734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderAudit/dcopsCrossAudit.vue"
export default component.exports